var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "el-sp-left"
  }, [_vm.tabData.length > 0 ? _c('el-tabs', {
    attrs: {
      "stretch": true
    },
    on: {
      "tab-click": _vm.handlerTabChange
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, _vm._l(_vm.tabData, function (item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "disabled": _vm.showCurrentDept && item.id !== '0' ? true : false,
        "name": item.id,
        "label": item.name
      }
    }, [_c('el-tree', {
      ref: 'tree_' + index,
      refInFor: true,
      staticClass: "el-left-tree",
      attrs: {
        "data": _vm.innerTreeData,
        "empty-text": "无数据",
        "node-key": "id",
        "check-on-click-node": "",
        "highlight-current": true,
        "current-node-key": _vm.currentNodekey,
        "default-expanded-keys": _vm.expandedKeys
      },
      on: {
        "node-click": _vm.treeItemSelect
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          node
        }) {
          return _c('span', {
            staticClass: "text-trunc one-ellipsis"
          }, [_c('span', {
            staticClass: "one-ellipsis",
            attrs: {
              "title": node.label
            }
          }, [_vm._v(_vm._s(node.label))])]);
        }
      }], null, true)
    })], 1);
  }), 1) : _vm._e(), _vm.tabData.length === 0 ? _c('el-tree', {
    attrs: {
      "data": _vm.innerTreeData,
      "check-on-click-node": "",
      "empty-text": "无数据",
      "node-key": "id",
      "default-expanded-keys": _vm.expandedKeys
    },
    on: {
      "node-click": _vm.treeItemSelect
    }
  }) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };